document.addEventListener('DOMContentLoaded', function() {
  var hideTimers = new Map();
  document.querySelectorAll('.header-custom__nav-item').forEach(function(item) {
    if (!item.querySelector('.header-custom__mega-menu')) return;
    item.addEventListener('mouseenter', function() {
      if (hideTimers.has(item)) {
        clearTimeout(hideTimers.get(item));
        hideTimers.delete(item);
      }
      item.classList.add('mega-open');
    });
    item.addEventListener('mouseleave', function() {
      var t = setTimeout(function() {
        item.classList.remove('mega-open');
        hideTimers.delete(item);
      }, 150);
      hideTimers.set(item, t);
    });
  });
});

class ElphiCustomHeader extends HTMLElement {
  constructor() {
    super();
    const searchToggle = this.querySelector('[data-search-toggle]');
    const searchModal = this.querySelector('[data-search-modal]');
    if (searchToggle && searchModal) {
      searchToggle.addEventListener('click', () => {
        searchModal.classList.toggle('is-open');
        if (searchModal.classList.contains('is-open')) {
          searchModal.querySelector('input[type="search"]').focus();
        }
      });
      document.addEventListener('click', (e) => {
        if (!searchModal.contains(e.target) && !searchToggle.contains(e.target)) {
          searchModal.classList.remove('is-open');
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
          searchModal.classList.remove('is-open');
        }
      });
    }
    const mobileToggle = this.querySelector('[data-mobile-menu-toggle]');
    const mobileDrawer = document.querySelector('[data-mobile-drawer]');
    const mobileOverlay = document.querySelector('[data-mobile-overlay]');
    const mobileClose = document.querySelector('[data-mobile-close]');
    const openMobile = () => {
      mobileDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const closeMobile = () => {
      mobileDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    if (mobileToggle) mobileToggle.addEventListener('click', openMobile);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);
    if (mobileClose) mobileClose.addEventListener('click', closeMobile);
    document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-mobile-accordion]');
        item.classList.toggle('is-open');
      });
    });
  }
}
if (!customElements.get('elphi-custom-header')) customElements.define('elphi-custom-header', ElphiCustomHeader);